module.exports = __webpack_public_path__ + "static/media/big-cultec-waves-watermark-50.b4b2e792.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/big-cultec-waves-watermark-50.png
// module id = 3028
// module chunks = 0